import React, { useEffect, useState } from 'react';
import {
    Box, TextField, Button, Typography, Stack
} from '@mui/material';
import axios from 'axios';

const BuildingDetailsWallsAddWindow = ({ buildingId, wall, window, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        area: '',
        u_value: ''
    });

    useEffect(() => {
        if (window) {
            setFormData({
                name: window.name,
                area: window.area,
                u_value: window.u_value
            });
        }
    }, [window]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            area: parseFloat(formData.area),
            u_value: parseFloat(formData.u_value),
            wall: wall.id
        };

        const url = window
            ? `/buildings/${buildingId}/walls/${wall.id}/windows/${window.id}/`
            : `/buildings/${buildingId}/walls/${wall.id}/windows/`;

        const method = window ? axios.put : axios.post;

        method(url, payload)
            .then(() => {
                onSuccess();
            })
            .catch(() => {
                onError();
            });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2, width: 400 }}>
            <Typography variant="h6" gutterBottom mb={2}>
                {window ? 'Edit Window' : 'Add Window'}
            </Typography>

            <Stack spacing={2}>
                <TextField
                    label="Name"
                    name="name"
                    fullWidth
                    required
                    value={formData.name}
                    onChange={handleChange}
                />
                <TextField
                    label="Area"
                    name="area"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    fullWidth
                    required
                    value={formData.area}
                    onChange={handleChange}
                />
                <TextField
                    label="U-Value"
                    name="u_value"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    fullWidth
                    required
                    value={formData.u_value}
                    onChange={handleChange}
                />

                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" color="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" type="submit">
                        {window ? 'Save' : 'Add'}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BuildingDetailsWallsAddWindow;
